var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-listings-navigation"},[_c('vertical-navigation',{attrs:{"title":"Listings","links":_vm.links}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }